const BASE = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('dentalToken')}`, 'Content-Type': 'application/json' });
const DONE_KEY = 'drGDoneActions';

const call = async (path, opts = {}) => {
  const res = await fetch(`${BASE}${path}`, { headers: headers(), ...opts });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data.detail;
    throw new Error(Array.isArray(d) ? d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(' · ') : d || 'Something went wrong');
  }
  return data;
};

export const actionApi = {
  findPatients: (q) => call(`/api/dr-dan/patients?q=${encodeURIComponent(q || '')}`).then((d) => d.patients),
  sendMessage: (body) => call('/api/messages/send', { method: 'POST', body: JSON.stringify(body) }),
  saveDentist: (body) => call('/api/referral-dentists', { method: 'POST', body: JSON.stringify(body) }),
};

export const doneStatus = (key) => JSON.parse(localStorage.getItem(DONE_KEY) || '{}')[key];
export const markDone = (key, status) => {
  const all = JSON.parse(localStorage.getItem(DONE_KEY) || '{}');
  all[key] = status;
  localStorage.setItem(DONE_KEY, JSON.stringify(all));
};

const ACTION_RE = /```action\s*([\s\S]*?)```/g;

export const splitActions = (text) => {
  const actions = [];
  const clean = (text || '').replace(ACTION_RE, (_, body) => {
    try { actions.push(JSON.parse(body.trim())); } catch { /* still streaming or invalid */ }
    return '';
  }).replace(/```action[\s\S]*$/, '').trim();
  return { clean, actions };
};

export const speakable = (text) => splitActions(text).clean
  .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/https?:\/\/\S+/g, '').replace(/[*#`>]/g, '').replace(/\n+/g, '. ');
